// @flow

import { ReducerRegistry } from "../../../../../base/redux";
import { FEATURE_CUSTOM_PAYMENT } from "../../../../constant";
import { paginationObject, PaymentPages, subscriptionObj } from "../Utils";
import {
    SET_LEFT_MENU_STATUS,
    SET_NOTIFICATION,
    SET_PAYMENT_CONTACT,
    SET_PAYMENT_DASHBOARD_STATUS,
    SET_PAYMENT_HOSTED_ROOM,
    SET_PAYMENT_INVITATION_ROOM,
    SET_PAYMENT_INVITED_ROOM,
    SET_PAYMENT_SELECTED_PAGE,
    SET_TIMEZONES,
    SET_USER_SUBSCRIPTION,
    SET_WINDOW_REF,
    SET_INVITION_NOTIFICATION_COUNT,
    SHOW_PAYMENT_DASHBOARD,
    SET_AVAILABLE_SUB_PACKAGE,
    SET_PAID_ROOM_HISTORY,
    SET_SUBSCRIPTION_PAYMENT_HISTORY
} from "./actionType";

ReducerRegistry.register(FEATURE_CUSTOM_PAYMENT, (state = {
    willShowPaymentDashboard: false,
    paymentSelectedPage: PaymentPages.HOSTED_ROOM,
    paymentId: "",
    additionalPageDetail: null,
    isLeftMenuOpen: true,
    paymentHostedRoom: {
        list: [],
        pagination: paginationObject
    },
    paymentInvitedRoom: {
        list: [],
        pagination: paginationObject
    },
    paymentInvitationRoom: {
        list: [],
        pagination: paginationObject
    },
    paymentContact: {
        list: [],
        pagination: paginationObject
    },
    notificationMessage: {
        isOpen: false,
        message: null,
        type: null
    },
    windowRef: {
        win: null,
        uid: null,
        package_id: null
    },
    userPaymentSubscription: subscriptionObj,
    timezones: [],
    paymentPendingInvition: 0,
    isShowPaymentDashboard: false,
    subscriptionPackageList: {},
    paidRoomHistory: {
        list: [],
        pagination: paginationObject
    },
    subscriptionPaymentHistory: {
        list: [],
        pagination: paginationObject
    }
}, action) => {
    switch (action.type) {
        case SET_PAYMENT_DASHBOARD_STATUS:
            return {
                ...state,
                willShowPaymentDashboard: action.willShowPaymentDashboard,
            }
        case SET_PAYMENT_SELECTED_PAGE:
            return {
                ...state,
                paymentSelectedPage: action.paymentSelectedPage,
                paymentId: action.paymentId,
                additionalPageDetail: action.additionalPageDetail
            }
        case SET_LEFT_MENU_STATUS:
            return {
                ...state,
                isLeftMenuOpen: action.isLeftMenuOpen,
            }
        case SET_PAYMENT_HOSTED_ROOM:
            return {
                ...state,
                paymentHostedRoom: action.paymentHostedRoom,
            }
        case SET_PAYMENT_HOSTED_ROOM:
            return {
                ...state,
                paymentHostedRoom: action.paymentHostedRoom,
            }
        case SET_PAYMENT_INVITED_ROOM:
            return {
                ...state,
                paymentInvitedRoom: action.paymentInvitedRoom,
            }
        case SET_PAYMENT_INVITATION_ROOM:
            return {
                ...state,
                paymentInvitedRoom: action.paymentInvitedRoom,
            }

        case SET_PAYMENT_CONTACT:
            return {
                ...state,
                paymentContact: action.paymentContact,
            }
        case SET_NOTIFICATION:
            return {
                ...state,
                notificationMessage: action.notificationMessage,
            }
        case SET_WINDOW_REF:
            return {
                ...state,
                windowRef: action.windowRef,
            }
        case SET_USER_SUBSCRIPTION:
            return {
                ...state,
                userPaymentSubscription: action.userPaymentSubscription,
            }
        case SET_TIMEZONES:
            return {
                ...state,
                timezones: action.timezones,
            }

        case SET_INVITION_NOTIFICATION_COUNT:
            return {
                ...state,
                paymentPendingInvition: action.paymentPendingInvition,
            }
        case SHOW_PAYMENT_DASHBOARD:
            return {
                ...state,
                isShowPaymentDashboard: action.isShowPaymentDashboard
            }
        case SET_AVAILABLE_SUB_PACKAGE:
            return {
                ...state,
                subscriptionPackageList: action.subscriptionPackageList
            }
        case SET_PAID_ROOM_HISTORY:
            return {
                ...state,
                paidRoomHistory: action.paidRoomHistory,
            }
        case SET_SUBSCRIPTION_PAYMENT_HISTORY:
            return {
                ...state,
                subscriptionPaymentHistory: action.subscriptionPaymentHistory
            }

    }
    return state;
});